<template>
  <div class="impact-scale" data-test-id="impact-scale">
    <a
      :href="url"
      target="_blank"
      :aria-label="acessibleLinkLabel"
      class="impact-scale__link"
      data-test-id="impact-scale-link"
    >
      <div
        v-for="impactLevel in impactLevels"
        :key="`impact-option-${impactLevel[0]}`"
        class="impact-scale__level"
        :class="[{ 'impact-scale__level--selected' : (selectedLevel === impactLevel[0]) },
                 `impact-scale__level--${impactLevel[0]}` ]"
        :data-test-id="`impact-level-${impactLevel[0]}`"
      >
        {{ impactLevel[1] }}
      </div>
    </a>
  </div>
</template>
<script>
const IMPACT_LEVELS = [
  ['critically-insufficient', '4+°C'],
  ['highly-insufficient', '3-4°C'],
  ['insufficient', '2-3°C'],
  ['almost-sufficient', '<2°C'],
  ['paris-compatible', '<1.5°C'],
  ['role-model', '<<1.5°C'],
];
const CAT_RATING_SYSTEM_URL = 'https://climateactiontracker.org/countries/rating-system/';
export default {
  components: {
  },
  props: {
    level: {
      type: String,
      default: '',
    },
  },
  computed: {
    acessibleLinkLabel() {
      return this.$t('web.entitites.climateactiontracker.scalelink');
    },
    selectedLevel() {
      return this.level.replace('_', '-').toLowerCase();
    },
    impactLevels() {
      return IMPACT_LEVELS;
    },
    url() {
      return CAT_RATING_SYSTEM_URL;
    },
  },
};
</script>
<style lang="scss" scoped>
$selected-level-border: $space-s;
$selected-level-height: $space-2l;

@mixin impact-scale() {
  $level-colors: (
    critically-insufficient: (
      color: $c-claret-70,
      color-dark: $c-claret-50,
      text: $white,
      text-dark: $white,
    ),
    highly-insufficient: (
      color: $c-red-40,
      color-dark: $c-red-40,
      text: $black,
      text-dark: $black,
    ),
    insufficient: (
      color: $c-red-30,
      color-dark: $c-red-30,
      text: $black,
      text-dark: $black,
    ),
    almost-sufficient: (
      color: $c-yellow-40,
      color-dark: $c-yellow-40,
      text: $black,
      text-dark: $black,
    ),
    paris-compatible: (
      color: $c-light-green-40,
      color-dark: $c-light-green-40,
      text: $black,
      text-dark: $black,
    ),
    role-model: (
      color: $c-green-30,
      color-dark: $c-green-30,
      text: $black,
      text-dark: $black,
    ),
  );

  $keys: map-keys($level-colors);

  @each $level in $keys {
    $level-color: map-get($level-colors, $level);
    $color: map-get($level-color, 'color');
    $color-dark: map-get($level-color, 'color-dark');
    $text: map-get($level-color, 'text');
    $text-dark: map-get($level-color, 'text-dark');
    .impact-scale__level--#{$level} {
      background-color: $color;
      color: $text;
    }

    .dark {
      .impact-scale__level--#{$level} {
        background-color: $color-dark;
        color: $text-dark;
      }
    }
  }
}

@include impact-scale();

.impact-scale__link {
  width: 100%;
  display: inline-flex;
  justify-content: space-between;
  font-size: $font-s;
  height: 35px;
  align-items: center;
}

.impact-scale__level {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-right: $space-3s;
  line-height: $font-m;
  border-radius: $border-radius-1s;
  height: $space-1l;
  font-weight: $font-weight-1l;
  font-size: $font-1s;
}

.impact-scale__level--selected {
  height: $selected-level-height;
  font-size: $font-m;
}

.impact-scale__level:first-child {
  border-top-left-radius: $selected-level-border;
  border-bottom-left-radius: $selected-level-border;
}

.impact-scale__level:last-child {
  border-top-right-radius: $selected-level-border;
  border-bottom-right-radius: $selected-level-border;
}

.impact-scale__level:hover {
  text-decoration: none;
}
</style>
